import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  studyMatrialsAsync,
  materialSubjectChapterCountAsync,
  materialUserChapterBySubjectIdAsync,
  userStudyMatrialsAsync,
} from "./study.async";

const initialState = {
  studyLoader: false,
  studyData: [],
  subjectData: [],
  chaptersBySubject: [],
  studyMaterialByChapter: [],
};

export const studySlice = createSlice({
  name: "study",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        studyMatrialsAsync.pending,
        materialSubjectChapterCountAsync.pending,
        materialUserChapterBySubjectIdAsync.pending,
        userStudyMatrialsAsync.pending
      ),
      (state, action) => {
        state.studyLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(userStudyMatrialsAsync.fulfilled),
      (state, action) => {
        state.studyLoader = false;
        state.studyMaterialByChapter = action.payload.data;
      }
    );

    builder.addMatcher(
      isAnyOf(studyMatrialsAsync.fulfilled),
      (state, action) => {
        state.studyLoader = false;
        state.studyData = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(materialSubjectChapterCountAsync.fulfilled),
      (state, action) => {
        state.studyLoader = false;
        state.subjectData = action.payload.data;
      }
    );

    builder.addMatcher(
      isAnyOf(materialUserChapterBySubjectIdAsync.fulfilled),
      (state, action) => {
        state.studyLoader = false;
        state.chaptersBySubject = action.payload.data;
      }
    );

    builder.addMatcher(
      isAnyOf(
        studyMatrialsAsync.rejected,
        materialSubjectChapterCountAsync.rejected,
        materialUserChapterBySubjectIdAsync.rejected,
        userStudyMatrialsAsync.rejected
      ),
      (state, action) => {
        state.studyLoader = false;
      }
    );
  },
  reducers: {
    emptyStudy: () => initialState,
    resetStudyMaterial: (state) => {
      state.studyLoader = false;
    },
  },
});

export const { emptyStudy, resetStudyMaterial } = studySlice.actions;

export default studySlice.reducer;
